import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';

export const SHELTER_GET_SHELTER = graphql(`
  query ShelterGetShelter($where: DogShelterWhereInput, $take: Int) {
    findManyDogShelter(where: $where, take: $take) {
      id
      name
      agreementNumber
      emails
      phoneNumbers
      links {
        link
        name
      }
      translations {
        id
        language
        description
        additionalInfo
      }
      openingHours {
        dayOfWeek
        startTime
        endTime
      }
      spokenLanguages
      imgs {
        id
        small
        medium
        large
      }
      address {
        id
        country
        city
        street
        region
        zip
        lng
        lat
      }
    }
  }
`);

export const useGetShelter = (url: string) => {
  const { data, error, loading } = useQuery(SHELTER_GET_SHELTER, {
    variables: {
      take: 1,
      where: {
        translations: { some: { url: { equals: url } } },
      },
    },
  });

  return {
    shelter: data?.findManyDogShelter?.[0],
    shelterError: error,
    shelterLoading: loading,
  };
};
